// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4377":"b8c94fa73847275c","7542":"dd52130816117f71"}[chunkId] + ".css";
};